import { computed } from "mobx";
import { format } from "date-fns";

export default class Day {
  index: number;
  total: number;
  delta: number;
  deaths: number;
  ic: number;
  infected: number;
  date: Date;

  constructor(index, date, total, delta, deaths, ic, infected) {
    this.index = index;
    this.date = date;
    this.total = total;
    this.delta = delta;
    this.deaths = deaths;
    this.ic = ic;
    this.infected = infected;
  }

  @computed get label() {
    return format(this.date, "dd MMM");
  }
}
